import type { SetStateAction } from 'react';
import { useState } from 'react';
import { storageUtil } from '@goodfynd/utils';

export const useLocalStorageState = <T>(key: string, defaultValue?: T) => {
  const [state, setState] = useState(() => {
    if (typeof window === 'undefined') {
      return defaultValue;
    }
    return storageUtil.local.get<T>(key, defaultValue);
  });

  const setValue = (value: SetStateAction<T | undefined>) => {
    try {
      const update = value instanceof Function ? value(state) : value;
      setState(update);

      if (update) {
        storageUtil.local.set(key, JSON.stringify(update));
      } else {
        storageUtil.local.remove(key);
      }
    } catch (e) {
      console.error(e);
    }
  };
  return [state, setValue] as const;
};
